import { useCallback, useState } from 'react'

/**
 * Measures the rendered height of an element and returns it plus a callback
 * ref to attach. Used by the table screens to offset a sticky data table below
 * a variable-height header.
 *
 * @param extra pixels to add to the measured height (default 8)
 */
export function useMeasuredHeight(
  extra = 8
): [number, (node: HTMLElement | null) => void] {
  const [height, setHeight] = useState(0)
  const measuredRef = useCallback(
    (node: HTMLElement | null) => {
      if (node !== null) {
        setHeight(node.getBoundingClientRect().height + extra)
      }
    },
    [extra]
  )
  return [height, measuredRef]
}
